module.exports = __webpack_public_path__ + "4c6bf085b453eb2c184b9e65136b47e4.png";